import { SearchIndexProvider } from '@pcf-engineering/gatsby-plugin-pcs-fuse';
import { FeatureFlagProvider } from '@pcf-engineering/pcs-feature-flags';

import { StateProvider } from '../components/StateStore';

import { BladeProvider } from './BladeProvider';
import { MarketingQueryParamsProvider } from './MarketingQueryParamsProvider';
import { ModalProvider } from './ModalProvider';
import { ProvinceProvider } from './ProvinceProvider';

const RootProviders = ({ element }: { element: JSX.Element }) => (
  <FeatureFlagProvider>
    <ProvinceProvider>
      <StateProvider>
        <SearchIndexProvider>
          <ModalProvider>
            <BladeProvider>
              <MarketingQueryParamsProvider>
                {element}
              </MarketingQueryParamsProvider>
            </BladeProvider>
          </ModalProvider>
        </SearchIndexProvider>
      </StateProvider>
    </ProvinceProvider>
  </FeatureFlagProvider>
);

export default RootProviders;
